import jwt_decode from 'jwt-decode';

export class User {
  public id: number;
  public name: string;
  public languages: Array<any>;
  public currencies: Array<any>;
  public permissions: Array<any>;

  public static fromResponse(response) {
    const user = new User();
    user.id = response.id;
    user.name = response.name;
    user.languages = response.languages;
    user.currencies = response.currencies;
    user.permissions = response.permissions;

    return user;
  }

  public hasPermission(permission: string): boolean {
    return this.permissions.find(x => {
      return x.name === permission;
    });
  }

  public hasPermissionsAny(permissions: Array<any>): boolean {
    return permissions.filter(x => {
      return this.permissions.some(y => y.name === x);
    }).length > 0;
  }
}



// WEBPACK FOOTER //
// D:/Projects/bid/frontend/src/app/shared/models/user.model.ts